import React, { useState, useEffect } from "react";
import {
  Container,
  Col,
  Image,
  Row,
  Card,
  Form,
  Button,
  Modal,
  FloatingLabel,
} from "react-bootstrap";
import flowers from "../assets/Icon/flowers.png";
import Tulip from "../assets/Icon/Tulip.png";
import AllHeader from "../components/AllHeader";
import Modals from "../components/Modals";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import NotInfo from "../components/NotInfo";
import useCheckUser from "../custom-hooks/useCheckUser";
import { toast } from "react-toastify";
import axiosInstance from "../api/axiosInstance";
import BigLoader from "../components/BigLoader";

function Cemetery() {
  const [load, setLoad] = useState(false);
  const [fatherName, setFatherName] = useState("");
  const [seenFile, setSeenFile] = useState([]);
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [show, setShow] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const UserID = localStorage.getItem("UserId");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Example usage of the custom hook
  useCheckUser(UserID); // Replace UserID with the actual user ID value

  useEffect(() => {
    setLoad(true);
    axiosInstance
      .post("GetCem", {
        Name: name,
        Name_ph: fatherName,
        Date:
          typeof date !== "string"
            ? new Date(date).toLocaleDateString("fa-IR")
            : date,
      })
      .then((res) => {
        if (res.data.result === "true") {
          setSeenFile(res.data.data);
          setLoad(false);
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  }, [isSearch]);

  // search cemetry function
  const searchHandler = () => {
    if (isSearch === false) {
      setIsSearch(true);
    } else {
      setIsSearch(false);
    }
    setShow(false);
  };

  //Focus on the Next Field
  const handleEnter = (event) => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };

  return (
    <div className="pt-5">
      <AllHeader>
        <span>آرامستان</span>
      </AllHeader>
      <Container>
        <Row className="justify-content-start">
          <Col xs={12} className="text-center rgc-title">
            <Row>
              <Col xs={2} className="rgc-search-position text-center">
                <Button className="btn rgc-search-btn" onClick={handleShow}>
                  <i className="fa fa-search" aria-hidden="true"></i>
                </Button>
              </Col>
            </Row>

            <Row className="justify-content-start g-4">
              {
              load === false && seenFile.length === 0 ? (
                <NotInfo />
              ) : (
                seenFile.map((data, index) => {
                  return (
                    <Col xs={12} md={6} lg={4} key={index}>
                      <Card className="rgc-cards">
                        <Card.Body>
                          <Card.Title className="rgc-lists-title">
                            <Image src={data.type === 1 ? Tulip : flowers} />
                            {data.type === 1 ? (
                              <span>شهید {data.Name}</span>
                            ) : (
                              <span>{data.Name}</span>
                            )}
                          </Card.Title>
                          <hr />
                          <Card.Text>
                            <Row className="rgc-lists">
                              <Col xs={6}>
                                <div className="rgc-lists-txt">
                                  <div>تاریخ وفات:</div>
                                  <div>{data.Date}</div>
                                </div>
                              </Col>

                              <Col xs={6}>
                                <div className="rgc-lists-txt">
                                  <div>نام پدر:</div>
                                  <div>{data.FatherName}</div>
                                </div>
                              </Col>

                              <Col xs={6}>
                                <div className="rgc-lists-txt">
                                  <div>آرامگاه:</div>
                                  <div>{data.Arametan}</div>
                                </div>
                              </Col>

                              <Col xs={6}>
                                <div className="rgc-lists-txt">
                                  <div>قطعه:</div>
                                  <div>{data.Segment}</div>
                                </div>
                              </Col>

                              <Col xs={6}>
                                <div className="rgc-lists-txt">
                                  <div>ردیف:</div>
                                  <div>{data.Field}</div>
                                </div>
                              </Col>

                              <Col xs={6}>
                                <div className="rgc-lists-txt">
                                  <div>شماره:</div>
                                  <div>{data.Sh}</div>
                                </div>
                              </Col>

                              <Col xs={12}>
                                <div className="rgc-lists-txt">
                                  <div>توضیحات:</div>
                                  <div>{data.Comment}</div>
                                </div>
                              </Col>
                            </Row>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })
              )
              }
            </Row>
          </Col>
        </Row>
      </Container>

      <Modals show={show} handleClose={handleClose}>
        {/* clildren part */}
        <Form>
          <Row className="justify-content-start g-3">
            <Col xs={12} md={6} className="form-outline  rgc-input-icons">
              <FloatingLabel
                controlId="floatingInput"
                label="نام و نام خانوادگی"
              >
                <i className="fas fa-user"></i>
                <Form.Control
                  type="text"
                  autoComplete="off"
                  placeholder="نام و نام خانوادگی"
                  className="rgc-profile-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onKeyDown={handleEnter}
                />
              </FloatingLabel>
            </Col>

            <Col xs={12} md={6} className="form-outline  rgc-input-icons">
              <FloatingLabel controlId="floatingInput" label="نام پدر">
                <i className="fas fa-user-circle" aria-hidden="true"></i>
                <Form.Control
                  type="text"
                  autoComplete="off"
                  placeholder="نام پدر"
                  className="rgc-profile-input"
                  value={fatherName}
                  onChange={(e) => setFatherName(e.target.value)}
                  onKeyDown={handleEnter}
                />
              </FloatingLabel>
            </Col>

            {/* <Col xs={12} md={6} className="form-outline  rgc-input-icons">
                            <FloatingLabel
                                controlId="floatingInput"
                                label="آرامگاه"
                            >
                                <i className="fas fa-university" aria-hidden="true"></i>
                                <Form.Control
                                    type="text"
                                    autoComplete="off"
                                    placeholder="آرامگاه"
                                    className="rgc-profile-input" />
                            </FloatingLabel>
                        </Col> */}

            <Col xs={12} md={6} className="form-outline rgc-icon-date">
              <Form.Group>
                <i
                  className="far fa-calendar-check rgc-date"
                  aria-hidden="true"
                ></i>
                <DatePicker
                  placeholder="تاریخ وفات"
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  value={date}
                  onChange={setDate}
                />
              </Form.Group>
              {/* <FloatingLabel
                                controlId="floatingInput"
                                label="تاریخ وفات"
                            >
                                 <i className="far fa-calendar-check" aria-hidden="true"></i>
                                <Form.Control
                                    type="text"
                                    autoComplete="off"
                                    placeholder="تاریخ وفات"
                                    className="rgc-profile-input"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    />
                            </FloatingLabel> */}
            </Col>
          </Row>
        </Form>
        <Modal.Footer className="rgc-modal-button">
          <Button onClick={searchHandler} className="rgc-btn">
            جستجو
          </Button>
        </Modal.Footer>
      </Modals>
      <BigLoader loading={load} />
    </div>
  );
}

export default Cemetery;
